module.exports = __webpack_public_path__ + "img/2_13_1.ef17545b.jpg";